import { render, staticRenderFns } from "./exam-prev.vue?vue&type=template&id=4ded3bff&"
import script from "./exam-prev.vue?vue&type=script&lang=js&"
export * from "./exam-prev.vue?vue&type=script&lang=js&"
import style0 from "./exam-prev.vue?vue&type=style&index=0&id=4ded3bff&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports